import { Action, State, StateContext } from '@ngxs/store';

import { TributeInfo } from './tribute-info.model';
import * as TributeActions from './tribute-info.actions';

@State<TributeInfo>({
  name: 'tributeInfo',
  defaults: new TributeInfo()
})
export class TributeInfoState {
  @Action(TributeActions.SetTributeID)
  setTributeID(
    { getState, setState }: StateContext<TributeInfo>,
    { payload }: TributeActions.SetTributeID
  ) {
    const state = getState();
    setState({ ...state, id: payload });
  }
  @Action(TributeActions.SetTributeCompleted)
  setTribute(
    { getState, setState }: StateContext<TributeInfo>,
    { payload }: TributeActions.SetTributeCompleted
  ) {
    const state = getState();
    setState({ ...state, completed: payload });
  }
  @Action(TributeActions.SetTributeInfo)
  setTributeInfo(
    { getState, setState }: StateContext<TributeInfo>,
    { payload }: TributeActions.SetTributeInfo
  ) {
    const state = getState();
    const { id, ...newState } = payload;
    setState({ ...state, ...newState });
  }
}
